import { persistToken } from '../helpers/persistence';
import visitor, { HAS_LOGGED_IN } from '../../utils/visitor';
import tracking from '../../utils/tracking';
import { getUtmParams } from '../../utils/utm';
import localStorage from '../../utils/local-storage'; // analytics and env are left out for now
import { CREATE_SUCCESS as BOLIGAGENT_CREATE_SUCCESS } from './boligagents';

const API = '/api';
const AUTH_ENDPOINT = `${API}/auth`;
const USERS_ENDPOINT = `${API}/users`;
const ME_ENDPOINT = `${USERS_ENDPOINT}/me`;

const EMAIL = 'user/EMAIL';
export const EMAIL_SUCCESS = 'user/EMAIL_SUCCESS';
const EMAIL_FAIL = 'user/EMAIL_FAIL';

export const CONFIRMEMAIL_SUCCESS = EMAIL_SUCCESS; // @deprecated
export const SETMAIL_SUCCESS = EMAIL_SUCCESS; // @deprecated

const RESET_PASSWORD = 'user/RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'user/RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAIL = 'user/RESET_PASSWORD_FAIL';
const VERIFY_PASSWORD = 'user/VERIFY_PASSWORD';
export const VERIFY_PASSWORD_SUCCESS = 'user/VERIFY_PASSWORD_SUCCESS';
export const VERIFY_PASSWORD_FAIL = 'user/VERIFY_PASSWORD_FAIL';
const SET_PASSWORD = 'user/SET_PASSWORD';
export const SET_PASSWORD_SUCCESS = 'user/SET_PASSWORD_SUCCESS';
export const SET_PASSWORD_FAIL = 'user/SET_PASSWORD_FAIL';

const CREATE = 'user/CREATE';
export const CREATE_SUCCESS = 'user/CREATE_SUCCESS';
export const CREATE_FAIL = 'user/CREATE_FAIL';
const LOGIN = 'user/LOGIN';
export const LOGIN_SUCCESS = 'user/LOGIN_SUCCESS';
export const LOGIN_FAIL = 'user/LOGIN_FAIL';

const SESSION = 'user/SESSION';
export const SESSION_SUCCESS = 'user/SESSION_SUCCESS';
export const SESSION_FAIL = 'user/SESSION_FAIL';

export const LOGOUT = 'user/LOGOUT';

const SHOW_TENANT = 'tenant/SHOW';
const SHOW_TENANT_SUCCESS = 'tenant/SHOW_SUCCESS';
const SHOW_TENANT_FAIL = 'tenant/SHOW_FAIL';
const UPDATE_TENANT = 'tenant/UPDATE_TENANT';
export const UPDATE_TENANT_SUCCESS = 'tenant/UPDATE_TENNANT_SUCCES';
const UPDATE_TENANT_FAIL = 'tenant/UPDATE_TENANT_FAIL';

const CHANGE_PASSWORD = 'user/CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'user/CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAIL = 'user/CHANGE_PASSWORD_FAIL';
const USER_CONFIRMATION = 'user/CONFIRMATION';
export const USER_CONFIRMATION_SUCCESS = 'user/CONFIRMATION_SUCCESS';
const USER_CONFIRMATION_FAIL = 'user/CONFIRMATION_FAIL';
const CHANGENAME = 'user/CHANGENAME';
export const CHANGENAME_SUCCESS = 'user/CHANGENAME_SUCCESS';
const CHANGENAME_FAIL = 'user/CHANGENAME_FAIL';

const VERIFYEMAIL = 'user/VERIFYEMAIL';
export const VERIFYEMAIL_SUCCESS = 'user/VERIFYEMAIL_SUCCESS';
const VERIFYEMAIL_FAIL = 'user/VERIFYEMAIL_FAIL';

const initialState = {
  token: localStorage.getItem('token') || null,
  user: null,
  tenant: null,
  loading: 0,
  existingUser: Boolean(localStorage.getItem('user'))
};

export default function auth(state = initialState, action = {}) {
  switch (action.type) {
    case LOGOUT:
      return {
        ...state,
        user: null,
        tenant: null,
        boligagents: []
      };
    case SHOW_TENANT_SUCCESS:
      return {
        ...state,
        tenant: action.payload,
        loading: state.loading - 1
      };
    case SHOW_TENANT:
      return {
        ...state,
        loading: state.loading + 1
      };
    case VERIFYEMAIL_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          status: true
        }
      };
    case CONFIRMEMAIL_SUCCESS: {
      const returnValue = action.payload.email
        ? { email: action.payload.email, status: false }
        : {};
      return {
        ...state,
        user: {
          ...state.user,
          ...returnValue
        }
      };
    }
    case CHANGENAME_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          name: action.payload.name
        }
      };
    case SHOW_TENANT_FAIL:
      return {
        ...state,
        loading: state.loading - 1,
        tenant: null
      };
    case UPDATE_TENANT_SUCCESS:
      return {
        ...state,
        tenant: action.payload
      };
    case BOLIGAGENT_CREATE_SUCCESS:
      if (!action.payload.user) {
        return state;
      }
      if (state.token !== action.payload.user.token) {
        persistToken(action.payload.user.token);
      }
      return {
        ...state,
        token: action.payload.user.token,
        user: { ...action.payload.user }
      };
    case USER_CONFIRMATION_SUCCESS:
    case SESSION_SUCCESS:
    case CREATE_SUCCESS:
    case LOGIN_SUCCESS:
    case VERIFY_PASSWORD_SUCCESS: {
      visitor(HAS_LOGGED_IN, 1);
      const {
        token,
        email,
        name,
        cellphone,
        facebookId,
        meta,
        status
      } = action.payload;
      if (state.token !== token) {
        persistToken(token);
      }
      return {
        ...state,
        token,
        user: { email, name, cellphone, facebookId, meta, status }
      };
    }
    case LOGIN_FAIL:
      return {
        ...state
      };

    default:
      return state;
  }
}

export function changePassword(data) {
  return {
    types: [CHANGE_PASSWORD, CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_FAIL],
    promise: client => client.post(`${ME_ENDPOINT}/pass`, { data }),
    throwError: true
  };
}

export function create(data) {
  return {
    types: [CREATE, CREATE_SUCCESS, CREATE_FAIL],
    promise: client =>
      client
        .post(`${USERS_ENDPOINT}`, { data: { ...data, utm: getUtmParams() } })
        .then(payload => {
          tracking.action('user-signup');
          return payload;
        }),
    throwError: true
  };
}

export function login(data) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: client => client.post(`${AUTH_ENDPOINT}/login`, { data })
  };
}

// @deprecated
export function confirmEmail(data) {
  return {
    types: [EMAIL, EMAIL_SUCCESS, EMAIL_FAIL],
    promise: client => client.post(`${ME_ENDPOINT}/email`, { data })
  };
}

// @deprecated
export function setMail(data) {
  return {
    types: [EMAIL, EMAIL_SUCCESS, EMAIL_FAIL],
    promise: client => client.post(`${ME_ENDPOINT}/email`, { data })
  };
}

export function changeEmail(data) {
  return {
    types: [EMAIL, EMAIL_SUCCESS, EMAIL_FAIL],
    promise: client => client.post(`${ME_ENDPOINT}/email`, { data })
  };
}

export function changeName(data) {
  return {
    types: [CHANGENAME, CHANGENAME_SUCCESS, CHANGENAME_FAIL],
    promise: client => client.post(`${ME_ENDPOINT}/change-name`, { data })
  };
}

export function logout() {
  persistToken(null);
  return {
    type: LOGOUT
  };
}

export function getSession() {
  return {
    types: [SESSION, SESSION_SUCCESS, SESSION_FAIL],
    promise: client =>
      client.get(`${ME_ENDPOINT}`).catch(err => {
        if (err && err.message === 'HTTP_403') {
          persistToken(null);
        }
        throw err;
      })
  };
}

export function mapToObject(item, { obj = {}, splitKey = '-' } = {}) {
  const ENUM_DWELLING = ['room', 'townhouse', 'villa', 'apartment'];
  const ENUM_TIMEFRAME = ['nolimit', 'lt1y', 'gt1y'];

  item.forEach((value, key) => {
    let currentObj = obj;

    const keys = splitKey ? key.split(splitKey) : [];
    const currentKey = keys.pop();
    if (keys.length) {
      currentObj = keys.reduce((acc, key) => {
        const curr = acc[key] || {};
        acc[key] = curr;
        return curr;
      }, obj);
    }

    if (value === true) {
      if (ENUM_DWELLING.indexOf(currentKey) !== -1) {
        currentObj.push(currentKey);
        return;
      }
      if (ENUM_TIMEFRAME.indexOf(currentKey) !== -1) {
        currentObj.push(currentKey);
        return;
      }
    }

    currentObj[currentKey] = value;
  });

  return obj;
}

export function getTenant() {
  return {
    types: [SHOW_TENANT, SHOW_TENANT_SUCCESS, SHOW_TENANT_FAIL],
    promise: client => client.get(`${ME_ENDPOINT}/tenant`)
  };
}

export function updateTenant(data) {
  return {
    types: [UPDATE_TENANT, UPDATE_TENANT_SUCCESS, UPDATE_TENANT_FAIL],
    promise: client =>
      client.post(`${ME_ENDPOINT}/tenant`, {
        data: mapToObject(data, {
          obj: { housing: { dwelling: [], timeframe: [] } }
        })
      })
  };
}

export function userConfirmation({ token }) {
  return {
    types: [
      USER_CONFIRMATION,
      USER_CONFIRMATION_SUCCESS,
      USER_CONFIRMATION_FAIL
    ],
    promise: client => client.get(`${USERS_ENDPOINT}/verify?token=${token}`)
  };
}

export function resetPassword({ email }) {
  return {
    types: [RESET_PASSWORD, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_FAIL],
    promise: client =>
      client.put(`${USERS_ENDPOINT}/reset-password`, { data: { email } })
  };
}
export function verifyNewPassword(data) {
  return {
    types: [VERIFY_PASSWORD, VERIFY_PASSWORD_SUCCESS, VERIFY_PASSWORD_FAIL],
    promise: client =>
      client.post(`${USERS_ENDPOINT}/verify-password`, { data })
  };
}

export function setPassword(data) {
  return {
    types: [SET_PASSWORD, SET_PASSWORD_SUCCESS, SET_PASSWORD_FAIL],
    promise: client => client.put(`${ME_ENDPOINT}/set-password`, { data })
  };
}

export function verifyEmail(data) {
  return {
    types: [VERIFYEMAIL, VERIFYEMAIL_SUCCESS, VERIFYEMAIL_FAIL],
    promise: client => client.post(`${ME_ENDPOINT}/verify-email`, { data })
  };
}

// export function serialize() {
//   return null;
// }

// export function deserialize() {
//   return { ...initialState };
// }
